<template>
<div class="serviceDetail page">
  <div v-if="loading" class="d-flex justify-center">
    <v-progress-circular :size="50" color="primary" indeterminate/>
  </div>
  <div v-if="Object.entries(error).length">
    {{error}}
  </div>
  <div v-else>
    <!-- Компонент _id -->
    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <div class="serviceDetail__wrapper" >
      <div class="title">
        <h2>
          {{serviceDetailPreview.name}}
        </h2>
      </div>

      <div class="short__description">
        <div class="wrapper ">
          <div class="text block" >
            <p>
              {{serviceDetailPreview.short_description}}
            </p>
            <div class="btnDownBlocks">
<!--              <div class="d-flex ">-->
<!--                <v-btn-->
<!--                  large-->
<!--                  color="white"-->
<!--                  outlined-->
<!--                >-->
<!--                  Добавить в корзину-->
<!--                </v-btn>-->
<!--              </div>-->
              <div v-if="serviceDetailPreview" >
                <v-btn
                  class="background_transparent mr-2"
                  large
                  color="white"
                  outlined
                  @click="sampleReport()"
                >
                  Образец отчета
                </v-btn>
              </div>
            </div>
          </div>
          <div class="image" v-if="mainImageModule && mainImageModule.images.length">
            <v-img
              :src="mainImageModule.images[mainImageModule.images.length - 1].image_url"
              :contain="true"
              aspect-ratio="1"
            />
          </div>
        </div>
      </div>

      <div class="full__description block"  >
        <div class="text">
          <p>
            {{serviceDetailPreview.full_description}}
          </p>
        </div>
      </div>

      <div class="cards block" v-if="cardsModule" >
        <div class="title">
          <h3>
            {{cardsModule.text}}
          </h3>
        </div>
        <div class="wrapper" >
          <div v-for="card of cardsModule.images" :key="card.id">
            <div class="card" v-if="card.image_url && card.caption">
              <div class="image">
                <v-img
                  :src="card.image_url"
                  :contain="true"
                />
              </div>
              <div class="text">
                {{card.caption || 'текст отсутствует'}}
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="consult block" v-if="contactButtonModule">
        <div class="text col-8">
          <p>{{contactButtonModule.text}}</p>
        </div>
        <div class="btnDownBlocks">
          <div class="d-flex col-4">
            <v-btn
              large
              color="white"
              outlined
              @click="goToLink()"
            >
              Связаться с менеджером
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/**
 * Компонент: _id
 * Описание:
 */
export default {
  name: 'serviceDetail',

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      serviceDetailPreview: 'services/services/GET_DETAIL_SERVICE_PREVIEW',
      user: 'auth/user',
      loading: 'services/services/GET_LOADING_SERVICES',
      error: 'services/services/GET_ERROR_STATE',
    }),
    breadcrumbs() {
      return [
        { title: 'Каталог услуг', url: '/list-services' },
        { title: `${this.serviceDetailPreview.name}`, url: '' },
      ];
    },
    // Modules
    mainImageModule() {
      if (!this.serviceDetailPreview.modules || this.serviceDetailPreview.modules.length === 0) {
        return null;
      }

      return this.serviceDetailPreview.modules.find(module =>
        module.module_type === 'main_image' && module.images && module.images.length > 0
      );
    },
    cardsModule() {
      if (!this.serviceDetailPreview.modules || this.serviceDetailPreview.modules.length === 0) {
        return null;
      }

      return this.serviceDetailPreview.modules.find(module =>
        module.module_type === 'features' && module.images && module.images.length > 0
      );
    },
    contactButtonModule() {
      if (!this.serviceDetailPreview.modules || this.serviceDetailPreview.modules.length === 0) {
        return null;
      }

      return this.serviceDetailPreview.modules.find(module =>
        module.module_type === 'contact_button'
      );
    },
    previewModule() {
      if (!this.serviceDetailPreview.modules || this.serviceDetailPreview.modules.length === 0) {
        return null;
      }

      return this.serviceDetailPreview.modules.find(module =>
        module.module_type === 'report_preview'
      );
    },
  },

  watch: {},

  async created() {
    try {
     const res = await this.GET_DETAIL_SERVICE(this.$route.params.id);
      if (!res.is_visible) {
        await this.$router.push({ path: '/404' });
      }
    } catch (e) {
      if (e.status === 404) {
        await this.$router.push({ path: '/404' });
      }
    }
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...(mapActions(
      {
        GET_DETAIL_SERVICE: 'services/services/GET_DETAIL_SERVICE'
      }
    )),
    goToSampleReport(id) {
      this.$router.push({ name: 'reportSample', params: { id } });
    },
    goToLink() {
      window.open('https://t.me/Team_Assessment', '_blank');
    },
    sampleReport() {
      if (this.previewModule.files?.length > 0) {
        window.open(this.previewModule.files[0].file_url, '_blank');
      } else {
        this.goToSampleReport(this.serviceDetailPreview.id);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.serviceDetail {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: self-start;
  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 1000px;
  }
  & .title{
    max-width: 950px!important;
  }
  & .block{
    background: white;
    padding: 16px;
    border-radius: 8px;
    max-width: 1000px;
  }
  & .text{
    font-size: 16px;
    line-height: 24px;
    white-space: pre-wrap;
    & p{
      margin: 0;
    }
  }
  & .short__description{
    & .wrapper{
      display: flex;
      flex-wrap: nowrap;
      gap: 32px;
      justify-content: space-between;

    }
    & .text{
      padding: 24px;
      max-width: 860px;
      font-size: 16px;
      line-height: 24px;
      & p{
        margin: 0;
        padding-bottom: 20px;
      }
    }
  }
  & .full__description {
    & .text p{
      line-height: 24px;
    }
  }
  & .btnDownBlocks{
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    & .v-btn{
      background: var(--color-blue-500);
      border-radius: 6px;
      height: 100%;
      font-size: 16px;
      padding: 10px 16px;
      ::v-deep span{
        line-height: 24px;
      }
      &.background_transparent{
        background: transparent;
        color: var(--color-blue-500)!important;
      }
    }
  }
  & .image{
    width: 100%;
    height: 100%;
    max-width: 255px;
    max-height: 255px;
  }
  & .consult{
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    & p{
      margin: 0;
    }
  }
  & .cards.block{
    & .title{
      padding-bottom: 16px;
    }
    & .wrapper{
      display: flex;
      flex-wrap: nowrap;
      gap: 16px;
      & .card{
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        gap: 4px;
        border: 1px solid var(--color-blue-500);
        padding: 16px;
        border-radius: 20px;
        max-width: 312px;
        height: 100%;

        & .image{
          width: 100%;
          height: 100%;
          padding: 16px;
          max-width: 216px;
          max-height: 172px;
          & .v-image{
            max-width: 216px;
            max-height: 142px;
          }
        }
        & .text{
          width: 100%;
        }
      }
    }

  }
  /* Стили компонента */
}
</style>
